import pako from 'pako'

export class AppWebSocketCompress {
    constructor(connectionPath, ctx, dispatchMessage, repeatDelay) {
        // console.log('AppWebSocket constructor', connectionPath, ctx, dispatchMessage, repeatDelay)
        const wsProtocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
        this.fullConnectionPath = wsProtocol + window.location.host + connectionPath
        this.ctx = ctx
        this.dispatchMessage = dispatchMessage
        this.repeatDelay = repeatDelay
    }

    connectSocket() {
        const self = this
        // console.log('Try connection to ' + this.fullConnectionPath)
        this.connection = new WebSocket(this.fullConnectionPath);
        this.connection.onmessage = function(event) {self.onMessageSocket(event)}
        this.connection.onopen = function() {self.onOpenSocket()}
        this.connection.onclose = function() {self.onCloseSocket()}
        this.connection.onerror = function() {self.onErrorSocket()}
    }

    onMessageSocket(event) {
        console.log("onMessageSocket ")
        let compressedData = Uint8Array.from(atob(event.data), (c) => c.charCodeAt(0));
        let decompressedData = pako.inflate(compressedData, { to: "string" });
        let data_json = JSON.parse(decompressedData);
        this.ctx.dispatch(this.dispatchMessage, data_json)
    }

    onOpenSocket() {
        // console.log("Successfully connected to " + this.fullConnectionPath, this);
    }

    onCloseSocket() {
        const self = this
        console.error('Socket closed unexpectedly');
        setTimeout(function() {self.connectSocket()}, self.repeatDelay);
    }

    onErrorSocket(err) {
        console.error('Socket encountered error: ', err, 'Closing socket');
        this.connection.close();
    }

}
